<template>
  <div class="circle-animation">
    <div class="circle-container"
         v-for="circle in 4"
         :key="'circle_'+circle"
         :class="[`circle--${circle}`, circleClasses]">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
        <circle cx="50" cy="50" :r="48 - 8 * (circle - 1)"/>
      </svg>
    </div>
    <transition name="fade" mode="out-in">
      <div class="error-container" v-show="$props.stopAnimation">
        <img src="/assets/images/close_red.svg" alt=""/>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'loader-spinner',
  props: {
    size: {
      type: String,
      default: 'normal',
      validator: value => {
        const allowedSizes = ['normal', 'md']
        return allowedSizes.includes(value)
      }
    },
    stopAnimation: Boolean
  },
  computed: {
    circleClasses () {
      return {
        [`size-${this.$props.size}`]: this.$props.size,
        'stop-animation': this.$props.stopAnimation
      }
    }
  }
}
</script>

<style scoped lang="scss">
.circle-animation {
  min-height: 70px;
  height: auto;
  width: 100%;
  display: block;
  position: relative;
}

.error-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: inline-block;
  width: 12px;
  height: 12px;

  img {
    width: 12px;
    height: auto;
  }
}

.circle-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: inline-block;
  width: 48px;
  height: 48px;

  circle {
    fill: transparent;
    stroke: $primary;
    stroke-width: 2;
    transform-origin: 50% 50%;
  }

  svg {
    animation: 3s linear infinite svg-animation;
  }

  &.circle--1 circle {
    stroke-dashoffset: 100; //max 302
    stroke-dasharray: 302;
    animation: 2.5s linear infinite both circle-animation--one;
  }

  &.circle--2 circle {
    stroke-dashoffset: 50; //max 252
    stroke-dasharray: 252;
    animation: 2.25s linear infinite both circle-animation--two;
    animation-delay: 0.5s;
  }

  &.circle--3 circle {
    stroke-dashoffset: 80; //max 201
    stroke-dasharray: 201;
    animation: 2s linear infinite both circle-animation--three;
  }

  &.circle--4 circle {
    stroke-dashoffset: 40; //max 151
    stroke-dasharray: 151;
    animation: 1.75s linear infinite both circle-animation--four;
    animation-delay: 0.5s;
  }

  &.circle--2 svg, &.circle--4 svg {
    animation: 2s linear infinite svg-animation--back;
  }

  &.stop-animation circle, &.stop-animation svg {
    animation-play-state: paused;
  }
}

.circle-container.size-md {
  width: 80px;
  height: 80px;
}

@keyframes circle-animation--one {
  0% {
    stroke-dashoffset: 50;
    transform: rotate(0)
  }
  50% {
    stroke-dashoffset: 240;
    transform: rotate(270deg)
  }
  100% {
    stroke-dashoffset: 50;
    transform: rotate(360deg);
  }
}

@keyframes circle-animation--two {
  0% {
    stroke-dashoffset: 80;
    transform: rotate(0)
  }
  50% {
    stroke-dashoffset: 200;
    transform: rotate(-180deg)
  }
  100% {
    stroke-dashoffset: 80;
    transform: rotate(-360deg);
  }
}

@keyframes circle-animation--three {
  0% {
    stroke-dashoffset: 30;
    transform: rotate(0)
  }
  50% {
    stroke-dashoffset: 140;
    transform: rotate(180deg)
  }
  100% {
    stroke-dashoffset: 30;
    transform: rotate(360deg);
  }
}

@keyframes circle-animation--four {
  0% {
    stroke-dashoffset: 20;
    transform: rotate(0)
  }
  50% {
    stroke-dashoffset: 120;
    transform: rotate(-90deg)
  }
  100% {
    stroke-dashoffset: 20;
    transform: rotate(-360deg);
  }
}

@keyframes svg-animation {
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg)
  }
}

@keyframes svg-animation--back {
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(-360deg)
  }
}
</style>
